import dayjs, { type ConfigType } from 'dayjs';

export function dateCell(value: ConfigType, format = 'D MMM, YYYY') {
  return <>{dayjs(value).format(format)}</>;
}
